// extracted by css-extract-rspack-plugin
export default {"root":"XzT992qtzcjcxYYa","indicator":"XY2VDJ_98boEhHOu","icon":"K5Eb2FCOZUXVRVzk","text":"HilDQ9WZiNMPnf2Q","ellipsis":"nx7t1vbLbUQebpDB","ellipsis-pulse":"IMhdXvdDp0nCirmv"};